module.exports = __webpack_public_path__ + "media/images/icons/icon_eye-da8c86f48d311a9ba4d2a8cf122d78b2.svg";